import * as React from "react";
import ScrollUpButton from "../Component/ScrollUpButton";
import LanguageFloating from "../Component/LanguageFloating";

export default class EmptyLayout extends React.Component {

    render() {
        return (<React.Fragment>
            {this.props.children}
            <LanguageFloating />
            <ScrollUpButton />
        </React.Fragment>)
    }
}